<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div class="personal-details">
        <div class="header-block">
          <div class="header-title">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <div class="add-block">
            <select style="text-align: center;margin-bottom: 0;margin-right: 10px;" class="form-control" (change)="dealerChange()" [(ngModel)]="dealerId">
                <option value="">select dealer</option>
                <option *ngFor="let list of dealerList" value="{{list.idealerId}}">{{list.name}}</option>
            </select>
            <!-- <div class="search">
              <form autocomplete="off" >
                <input type="text" (keyup.enter)="getObjectInfoByWildSearch()" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter" placeholder="search">
              </form>
              <i class="bi bi-search" (click)="getObjectInfoByWildSearch()"></i>
            </div> -->
            <!-- <button data-toggle="modal" data-target="#deviceModal"><i class="bi bi-plus-lg"></i> Add</button> -->
            <div class="filter-icon">
              <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshTickets()"></i>
            </div>
          </div>
        </div>
        <div class="row map-block">
          <div class="col-md-8 col-lg-8" [ngClass]="{'col-lg-4 col-md-4': showFilter || detailShow}">
            <div class="map-container" [ngClass]="[isFullscreen ? bi_fullscreen : '']">
              <div class="map-frame">
                <i class="bi bi-fullscreen" [ngClass]="isFullscreen ? 'bi-fullscreen-exit' : 'bi-fullscreen'" 
      (click)="toggleFullscreen()"></i>
                <div id="map">
                </div>
              </div> 
            </div>
          </div>
          <div class="col-lg-4 col-md-4 detailShow" *ngIf="detailShow">
            <div class="service-data" *ngFor="let viewData of singleObjectInfoData">
              <div class="close-i">
                <i class="bi bi-x-lg" (click)="closeDetailView()"></i>
              </div>

             <div class="form-group">
                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.objectInfoId' | translate }} :</label>
                    <p>{{viewData.objectInfoId || '--'}}</p>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.name' | translate }} :</label>
                    <p>{{viewData.name || '--'}}</p>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.givenName' | translate }} :</label>
                    <p>{{viewData.givenName || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.serialNumberCheckBox">
                    <label>{{ 'object-info.serialNumber' | translate }} :</label>
                    <p>{{viewData.serialNumber || '--'}}</p>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.group' | translate }} :</label>
                    <p>{{viewData.group || '--'}}</p>
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.type' | translate }} :</label>
                    <p>{{viewData.type || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.modelCheckBox">
                    <label>{{ 'object-info.model' | translate }} :</label>
                    <p>{{viewData.model || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.makeCheckBox">
                    <label>{{ 'object-info.make' | translate }} :</label>
                    <p>{{viewData.make || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.objectCondition' | translate }} :</label>
                    <p>{{viewData.objectCondition || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>Asset Status :</label>
                    <p>{{viewData.assetStatus || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.originalCostCheckBox">
                    <label>{{ 'object-info.originalCost' | translate }} :</label>
                    <p>{{viewData.originalCost || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.currentCostCheckBox">
                    <label>{{ 'object-info.currentCost' | translate }} :</label>
                    <p>{{viewData.currentCost || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.branchCheckBox">
                    <label>{{ 'object-info.branch' | translate }} :</label>
                    <p>{{viewData.branch || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.departmentCheckBox">
                    <label>{{ 'object-info.department' | translate }} :</label>
                    <p>{{viewData.department || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.location' | translate }} :</label>
                    <p>{{viewData.location || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.country' | translate }} :</label>
                    <p>{{viewData.country || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.provinceOrState' | translate }} :</label>
                    <p>{{viewData.provinceOrState || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.zone' | translate }} :</label>
                    <p>{{viewData.zone || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.postalCode' | translate }} :</label>
                    <p>{{viewData.postalCode || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.city' | translate }} :</label>
                    <p>{{viewData.city || '--'}}</p>
                  </div>


                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.createdDate' | translate }} :</label>
                    <p>{{viewData.createdDate | date}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.acquisitionDate' | translate }} :</label>
                    <p>{{viewData.acquisitionDate || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.depreciationCheckbox">
                    <label>{{ 'object-info.salvageValue' | translate }} :</label>
                    <p>{{viewData.salvageValue || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.depreciationCheckbox">
                    <label>{{ 'object-info.depreciationMethod' | translate }} :</label>
                    <p>{{viewData.depreciationMethod || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6" *ngIf="viewData.departmentCheckBox">
                    <label>{{ 'object-info.assetLifeNumber' | translate }} :</label>
                    <p>{{viewData.assetLifeNumber || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.asset_Category' | translate }} :</label>
                    <p>{{viewData.asset_Category || '--'}}</p>
                  </div>
                  <div class="col-md-12 col-lg-12 qr-code" >
                    <label>{{ 'object-info.qr_code' | translate }} :</label>
                  </div>

                  
                  <div class="col-md-12 col-lg-12" >
                    <div class="image-container" style="margin-top: 20px;">
                      <div class="image-header image-header1">
                        <h5>{{ 'object-info.images' | translate }}</h5>
                      </div>
                

                <div class="image-content-block">
                  <div class="image-single" *ngFor="let image of imagesWithDetails;let i = index">
                    <p>{{image.name}}</p>
                    <img src="{{image.image}}" (click)="selectLargeImage(image.image)" alt="">
                    <!-- <button (click)="removeImage(i)">Remove</button> -->
                  </div>
                  <div class="large-image-view" *ngIf="largeImage != ''">
                    <img src="{{largeImage}}" alt="">
                    <button (click)="selectLargeImage('')">{{ 'generic.close' | translate }}</button>
                  </div>
                </div>

             

                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12" *ngIf="viewData.nameValue && viewData.nameValue.length != 0">
                    <h5 class="data-list-title">{{ 'object-info.nameValue' | translate }}</h5>
                  </div>

                  <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.nameValue && viewData.nameValue.length != 0">
                    
                    <div class="list-block">
                      <ul class="ui-tree">
                        <ng-container *ngFor="let item of viewData.nameValue">
                          <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: item }"></ng-container>
                        </ng-container>
                      </ul>

                      <ng-template #renderNode let-node>
                        <li>
                          <strong>{{ node.key }}:</strong> {{ node.value }}
                          <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                            <ng-container *ngFor="let child of node.keyValue">
                              <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: child }"></ng-container>
                            </ng-container>
                          </ul>
                        </li>
                      </ng-template>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12" *ngIf="viewData.performanceMatrix && viewData.performanceMatrix.length != 0">
                    <h5 class="data-list-title">{{ 'object-info.performanceMatrix' | translate }} </h5>
                  </div>


                  <div class="col-md-12 col-lg-12" *ngIf="viewData.warranty">
                    <h5 class="data-list-title">{{ 'object-info.warranty' | translate }}</h5>
                  </div>

                  <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.warranty">
                    <div class="list-block">
                      <ul class="ui-tree">
                        <li *ngFor="let warrantyInfo of viewData.warrantyInfo">
                          <strong>{{ warrantyInfo.key }}:</strong> {{ warrantyInfo.value }}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12" *ngIf="viewData.purchase">
                    <h5 class="data-list-title">{{ 'object-info.purchase' | translate }}</h5>
                  </div>

                  <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.purchase">
                    <div class="list-block">
                      <ul class="ui-tree">
                        <li *ngFor="let purchaseInfo of viewData.purchaseInfo">
                          <strong>{{ purchaseInfo.key }}:</strong> {{ purchaseInfo.value }}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.performanceMatrix && viewData.performanceMatrix.length != 0 && !editPerformanceMatrix">
                    
                    <div class="list-block">
                      <ul class="ui-tree">
                        <ng-container *ngFor="let item of viewData.performanceMatrix">
                          <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: item }"></ng-container>
                        </ng-container>
                      </ul>

                      <ng-template #renderNode1 let-node>
                        <li>
                          <strong>{{ node.key }}:</strong> {{ node.value }}
                          <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                            <ng-container *ngFor="let child of node.keyValue">
                              <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: child }"></ng-container>
                            </ng-container>
                          </ul>
                        </li>
                      </ng-template>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="maintenanceScheduleList && maintenanceScheduleList.length != 0">
                    <h5 class="maintenance-list-title">{{ 'maintenance-schedule.title' | translate }}</h5>
                    
                    <div class="maintenance-list-block">
                      <div class="list" *ngFor="let list of maintenanceScheduleList">
                      
                        <div class="list1">
                            <div>
                              <label>{{ 'maintenance-schedule.maintenanceType' | translate }} :</label> 
                              <p>{{getMaintenanceType(list.maintenanceType) || '--'}}</p>
                            </div>
                            <div>
                              <label>{{ 'maintenance-schedule.frequency' | translate }} :</label> 
                              <p>{{list.frequency || '--'}}</p>
                            </div>
                            <div>
                              <label>{{ 'maintenance-schedule.nextDueDate' | translate }} :</label> 
                              <p>{{list.nextDueDate || '--'}}</p>
                            </div>
                            <div>
                              <label>{{ 'maintenance-schedule.lastPerformed' | translate }} :</label> 
                              <p>{{list.lastPerformed || '--'}}</p>
                            </div>
                        </div>
                      <div>
                          <label>{{ 'maintenance-schedule.description' | translate }} :</label> 
                          <p>{{list.description || '--'}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
    
                  <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="viewData.repairInfos && viewData.repairInfos.length != 0">
                    <h5 class="repair-list-title">{{ 'object-info.repairList' | translate }}</h5>
                    
            


                    <div class="repair-list-block">
                      <div class="list" *ngFor="let list of viewData.repairInfos">
                        <div>
                          <p><label>{{ 'object-info.repairDone' | translate }} :</label> {{list.description || '--'}}</p>
                        </div>

                        <div class="dates">
                          <p><label>{{ 'object-info.repairGivenTo' | translate }} :</label> {{list.repairGivenTo || '--'}}</p>
                          <p><label>{{ 'object-info.userName' | translate }} :</label> {{list.userName || '--'}}</p>
                          <p><label>{{ 'object-info.phNo' | translate }} :</label> {{list.phNo || '--'}}</p>
                          <p><label>{{ 'object-info.emailId' | translate }} :</label> {{list.emailId || '--'}}</p>
                          <p><label>{{ 'object-info.repairGivenDate' | translate }} :</label> {{list.repairGivenDate | date}}</p>
                          <p><label>{{ 'object-info.repairExpectedEndDate' | translate }} :</label> {{list.repairExpectedEndDate | date}}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="viewData.assetHealth && viewData.assetHealth.length != 0">
                    <h5 class="repair-list-title">{{ 'object-info.connections' | translate }}</h5>

                    <div class="row">
                      <div class="col-md-6 col-lg-6">
                        <label>{{ 'object-info.assetMonitoringFrequency' | translate }} :</label>
                        <p>{{viewData.assetMonitoringFrequency || '--'}}</p>
                      </div>

                      <div class="col-md-6 col-lg-6">
                        <label>{{ 'object-info.assetMonitoringTimeSpan' | translate }} :</label>
                        <p>{{viewData.assetMonitoringTimeSpan || '--'}}</p>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6 col-lg-6" *ngFor="let connectionDetails of viewData.connectionDetails">
                        <label>{{connectionDetails.key || '--'}} :</label> 
                        <p>{{connectionDetails.value || '--'}}</p>
                      </div>
                    </div>
                  </div>



                  <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="viewData.assetHealth && viewData.assetHealth.length != 0">
                    <h5 class="repair-list-title">{{ 'object-info.assetHealth' | translate }}</h5>

                    <div class="row">
                      <div class="col-md-6 col-lg-6" *ngFor="let assetHealthList of viewData.assetHealth">
                        <label>{{assetHealthList.key || '--'}} :</label> 
                        <p>{{assetHealthList.value || '--'}}</p>
                      </div>
                    </div>
                  </div>


    <!-- 
                  <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="viewData.repairInfos && viewData.repairInfos.length != 0">
                    <h5 class="repair-list-title">Repair List <span *ngIf="viewData.givenRepair" (click)="openRepairDone()">Repair Done</span></h5>
                    
                    <div class="repair-block" *ngIf="isRepairDone" [formGroup]="repairInfoForm">
                      <h5>Repair Done</h5>
                      <div class="form-group">
                        <label>Description</label>
                        <textarea name="" formControlName="description" id=""></textarea>
                      </div>

                      

                      <div class="action-repair">
                        <button type="button" class="btn btn-secondary" (click)="closeRepairDone()">Cancel</button>
                        <button type="button" (click)="addRepairInfos(false)" class="btn btn-primary">Repair Done</button>
                      </div>
                    </div>


                    <div class="repair-list-block">
                      <div class="list" *ngFor="let list of viewData.repairInfos">
                        <div>
                          <p><label>Description :</label> {{list.description || '--'}}</p>
                        </div>

                        <div class="dates">
                          <p><label>Company :</label> {{list.repairGivenTo || '--'}}</p>
                          <p><label>Name :</label> {{list.userName || '--'}}</p>
                          <p><label>Mobile :</label> {{list.phNo || '--'}}</p>
                          <p><label>Email :</label> {{list.emailId || '--'}}</p>
                          <p><label>Given Date :</label> {{list.repairGivenDate | date}}</p>
                          <p><label>Expected End Date :</label> {{list.repairExpectedEndDate | date}}</p>
                        </div>
                      </div>
                    </div>
                  </div> -->

                  

                <div class="nameValue">
                  <div>
                    <h5 class="multi-title">{{ 'object-info.assetPerformance' | translate }}</h5>

                    <div class="row keys-content">
                    
                      <div class="col-md-12 col-lg-12 keysBlock">
                        <div class="form-group">
                          <label for="">{{ 'object-info.timeSpan' | translate }}</label>
                        <p>{{viewData.assetPerformance?.timeSpan}}</p>

                        </div>

                        <div class="form-group">
                          <label for="">{{ 'object-info.uom' | translate }}</label>
                          <p>{{viewData.assetPerformance?.uom || '--'}}</p>
                        </div>

                        <div class="form-group">
                          <label for="">{{ 'object-info.expectedOutput' | translate }}</label>
                          <p>{{viewData.assetPerformance?.expectedOutput || '--'}}</p>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                  <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="viewData.tags && viewData.tags.length != 0">
                    <h5 class="repair-list-title">{{ 'object-info.tags' | translate }}</h5>
                    <div class="tag-list">
                      <p class="tag" *ngFor="let list of viewData.tags">{{list}}</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4" style="padding-left: 0;">
            <!-- <input type="text" placeholder="search" class="form-control"> -->
            <div class="customerList">
              <!-- <div class="list">
                <p *ngFor="let list of objectInfoList" (click)="getObjectInfoById(list.objectInfoId)">{{list.givenName}}</p>
              </div> -->
              <div class="list">
                <div class="locate-filter">
                  <button (click)="clearObject()">Clear</button>
                </div>
                <p [ngClass]="{'is-checked': list.isChecked}" *ngFor="let list of locationList" (click)="locationCheck($event, list)">
                  <!-- <input type="checkbox" (click)="$event.preventDefault()" [checked]="list.isChecked" > -->
                  <span></span>
                  {{list.zone}} - {{list.city}} - {{list.postalCode}}</p>
              </div>
              <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
              </div>

              <div class="loader" *ngIf="!isLoading && locationList.length == 0">
                <div class="no-data">
                  <img src="assets/no-data-6.png" alt="">
                  <p>no data found</p>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</div>